import $ from 'jquery';
import { gsap } from 'gsap';
import { ScrollToPlugin } from 'gsap/all';
gsap.registerPlugin(ScrollToPlugin);

$('.header--nav a').on('click', function(e){
    var link = $(this).attr('href');
    var isAnchorLink = link.startsWith("#");

    // If the user is on the home page and selects an anchor link
    if (isAnchorLink && window.location.pathname === '/') {
        e.preventDefault(); // Prevent the default behavior of the anchor tag
        gsap.to(window, {
            duration: 2,
            scrollTo: link,
            ease: 'Expo.easeOut'
        });
    } else if (!isAnchorLink) {
        // If the user is on any page and selects a non-anchor link, redirect them
        location.href = link;
    }

    // Close the mobile menu
    $('.js-hamburger').removeClass('is-active');
    $('.header').removeClass('mobile-active');
    gsap.to('.js-nav-mobile', {
        duration: 0.5,
        height: '0px',
        ease: 'Expo.easeOut'
    });
});

$('.header--nav-mobile a').on('click', function(e){
    var link = $(this).attr('href');
    var isAnchorLink = link.startsWith("#");
    $('body').removeClass('no-scroll');

    // If the user is on the home page and selects an anchor link
    if (isAnchorLink && window.location.pathname === '/') {
        e.preventDefault(); // Prevent the default behavior of the anchor tag
        gsap.to(window, {
            duration: 2,
            scrollTo: link,
            ease: 'Expo.easeOut'
        });
    } else if (!isAnchorLink) {
        // If the user is on any page and selects a non-anchor link, redirect them
        location.href = link;
    }

    // Close the mobile menu
    $('.js-hamburger').removeClass('is-active');
    $('.header').removeClass('mobile-active');
    gsap.to('.js-nav-mobile', {
        duration: 0.5,
        height: '0px',
        ease: 'Expo.easeOut'
    });
});

$('.js-hamburger').on('click', function(e){
    if ($(this).hasClass('is-active')) {
        // hide menu
        $(this).removeClass('is-active');
        $('.header').removeClass('mobile-active');
        $('body').removeClass('no-scroll');
        gsap.to('.js-nav-mobile', {
            duration: 0.5,
            height: '0px',
            ease: 'Expo.easeOut'
        });
    } else {
        // show menu
        $(this).addClass('is-active');
        $('body').addClass('no-scroll');

        $('.header').addClass('mobile-active');
        gsap.to('.js-nav-mobile', {
            duration: 1,
            height: window.innerHeight,
            ease: 'Expo.easeOut'
        });
    }
    e.preventDefault();
});